'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import type { ApiTravelType } from '../../../api/model';
import type { PartialPageProps } from '@/types/cms/magnolia';
import LazyWrapper from '@/components/lazyWrapper/LazyWrapper';
import dynamic from 'next/dynamic';

const TravelTypeTeaserCarousel = dynamic(
  () => import('@/components/travelTypeTeaser/TravelTypeTeaserCarousel'),
  { ssr: false }
);

const TravelTypeTeaserCarouselWrapper: FC<{
  travelTypes: Partial<ApiTravelType>[];
  pageProps?: PartialPageProps;
}> = ({ travelTypes, pageProps }): JSX.Element => {
  return (
    <LazyWrapper>
      <TravelTypeTeaserCarousel travelTypes={travelTypes} pageProps={pageProps} />
    </LazyWrapper>
  );
};

export default TravelTypeTeaserCarouselWrapper;
